import { render, staticRenderFns } from "./CyclePermissions.vue?vue&type=template&id=21c1c57c"
import script from "./CyclePermissions.vue?vue&type=script&lang=js"
export * from "./CyclePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports